import React, { ReactElement, useRef } from "react";
import {
  Box,
  Flex,
  Icon,
  useDisclosure,
  useTheme,
  Button,
  Text,
} from "@chakra-ui/react";
import { FaRegBell, FaRegQuestionCircle } from "react-icons/fa";
import { Theme } from "../theme";
import LogoutModal from "./LogoutModal";
import Cookies from "js-cookie";
import getAxios from "../hooks/useAxios";
import { decrypted } from "../utils/crypto";

export function Topbar() {
  const axios = getAxios();
  const theme = useTheme<Theme>();
  const {
    isOpen: isLogoutOpen,
    onOpen: onLogoutOpen,
    onClose: onLogoutClose,
  } = useDisclosure();
  const [logoutButtonLoading, setLogoutButtonLoading] = React.useState(false);

  const profile = decrypted(Cookies.get("x-z-user"));

  const handleLogOut = async () => {
    setLogoutButtonLoading(true);
    try {
      const res = await axios.get("/auth/users/logout", {
        headers: {
          Authorization: `Bearer ${Cookies.get("x-admin-auth")}`,
        },
      });
    } catch (error) {
      console.log("error while logout", error);
    }
    Cookies.remove("x-admin-auth");
    window.location.replace("/login");
    setLogoutButtonLoading(false);
  };

  return (
    <Flex sx={{ justifyContent: "flex-end" }}>
      <Flex
        sx={{
          gap: theme.space.xxl,
          // background: "#FFFFFF",
          padding: "0 2.4rem",
          height: "5rem",
          zIndex: 50,
          position: "relative",
        }}
      >
        <Flex sx={{ justifyContent: "center", alignItems: "center" }}>
          {/* <Button
            style={{
              height: "3rem",
            }}
            rightIcon={<FaRegQuestionCircle />}
          >
            Get Help
          </Button> */}

          <details
            style={{
              margin: "2rem",
              position: "relative",
              fontFamily: theme.fonts.body,
            }}
          >
            <summary
              style={{
                color: theme.colors.bg.main,
                height: "2.5rem",
                background: theme.colors.primary.main,
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                listStyle: "none",
                padding: "0 1rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: theme.fonts.body,
                fontSize: theme.fontSizes.body,
                fontWeight: 600,
                //@ts-ignore
                "&:hover": {
                  background: "red",
                },
              }}
            >
              Zippy
            </summary>
            <Popover className="user-popover"
              zIndex={350} top={"5rem"}

            >
              <Box height="100%">
                <Flex sx={{ marginBottom: theme.space.xxl }}>
                  <Box sx={{ marginRight: theme.space.lg }}>
                    <Flex
                      sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "0.25rem",
                        height: "3rem",
                        width: "3rem",
                        background: theme.colors.bg.paper,
                      }}
                    >
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading1,
                        }}
                      >
                        {profile?.name?.toUpperCase()?.charAt(0)}
                      </Text>
                    </Flex>
                  </Box>
                  <Flex sx={{ flexDirection: "column" }}>
                    <Text variant={"subHeading2"}>{profile?.name}</Text>
                    <Text variant={"label"} color={theme.colors.secondary.light}>{profile?.role?.toUpperCase()}</Text>
                    <Text
                      variant={"label"}
                      color={theme.colors.secondary.light}
                    >
                      {profile?.mobile}
                    </Text>
                  </Flex>
                </Flex>
                <Box>
                  <Button
                    style={{
                      width: "100%",
                      background: theme.colors.primary.main,
                      color: theme.colors.bg.main,
                    }}
                    onClick={onLogoutOpen}
                  >
                    Log Out
                  </Button>
                  <LogoutModal
                    isOpen={isLogoutOpen}
                    onClose={onLogoutClose}
                    onYesButtonClick={handleLogOut}
                    logoutButtonLoading={logoutButtonLoading}
                  />
                </Box>
              </Box>
            </Popover>
          </details>

          {/* <details
            style={{
              margin: "2rem",
              position: "relative",
              fontFamily: theme.fonts.body,
            }}
          >
            <summary
              style={{
                cursor: "pointer",
                listStyle: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Icon
                as={FaRegBell}
                width={7}
                height={7}
                color={theme.colors.primary.main}
                cursor="pointer"
              />
            </summary>
            <Popover
              className="notification-popover"
              zIndex={351}
              top={"4.4rem"}
            >
              <div>Notification</div>
            </Popover>
          </details> */}
        </Flex>
      </Flex>
    </Flex>
  );
}

function Popover({
  className,
  children,
  zIndex,
  top,
}: {
  className: string;
  children: ReactElement;
  zIndex: number;
  top: string;
}) {
  const theme = useTheme<Theme>();
  return (
    <Box
      className={className}
      style={{
        border: "1px solid",
        borderColor: theme.colors.divider,
        borderRadius: "0.25rem",
        position: "absolute",
        top: top,
        right: "0",
        // minHeight: "18rem",
        width: "max-content",
        minWidth: "16rem",
        padding: theme.space.xxl,
        background: "white",
        zIndex: zIndex,
        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
      }}
    >
      {children}
    </Box>
  );
}
